import React from 'react';

import s from './Modal.module.scss';

type Props = {
  tagline: React.ReactNode;
  title: React.ReactNode;
  text: React.ReactNode;
};

export const Verification = ({ tagline, title, text }: Props) => {
  return (
    <div className={s.verification}>
      {tagline && <p className={s.verification__tagline}>{tagline}</p>}
      {title && <h2 className={s.verification__title}>{title}</h2>}
      {text && <div className={s.verification__text}>{text}</div>}
    </div>
  );
};
